import React, { useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { MaskedField } from '@klarna/bubble-ui';

/** Borderless version of Bubble UI's `DateField` */
export const DateField = forwardRef((props, ref) => {
  const { name, onChange, monthAsLeftmost } = props;
  const [value, setValue] = React.useState('');

  const formatDateToDisplay = date => {
    if (!date || typeof date !== 'string') return '';
    const [year, month, day] = date.split('-');
    return monthAsLeftmost ? `${month}/${day}/${year}` : `${day}/${month}/${year}`;
  };

  const formatDateToSave = dateStr => {
    if (typeof dateStr !== 'string') return '';
    let day, month, year;
    if (monthAsLeftmost) {
      [month, day, year] = dateStr.split('/');
    } else {
      [day, month, year] = dateStr.split('/');
    }
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const formattedValueForDisplay = formatDateToDisplay(props.value);
    setValue(formattedValueForDisplay);
  }, [props.value]);

  const handleChange = newValue => {
    setValue(newValue);
    const formattedValueForSave = formatDateToSave(newValue);
    onChange(formattedValueForSave);
  };

  useEffect(() => {
    /** @type {HTMLInputElement} */
    const node = document.getElementById(name);

    if (node) {
      if (node.parentElement && node.parentElement.parentElement) {
        node.parentElement.style.top = 0;
        node.parentElement.style.position = undefined;
        node.parentElement.style.borderWidth = 0;

        node.parentElement.parentElement.style.padding = 0;
        node.parentElement.parentElement.style.marginTop = 0;
        node.parentElement.parentElement.style.borderStyle = 'none none solid none';
        node.parentElement.parentElement.style.borderRadius = 0;
      }
    }
  }, []);

  return (
    <div ref={ref}>
      <MaskedField
        {...props}
        isUnderlined
        type={undefined}
        value={value}
        onChange={handleChange}
        onChangeMaskedValue={setValue}
        mask={
          monthAsLeftmost
            ? [null, null, '/', null, null, '/', null, null, null, null]
            : [null, null, '/', null, null, '/', null, null, null, null]
        }
        placeholder={monthAsLeftmost ? 'MM/DD/YYYY' : 'DD/MM/YYYY'}
      />
    </div>
  );
});

DateField.displayName = 'DateField';

DateField.propTypes = {
  ...MaskedField.propTypes,
  monthAsLeftmost: PropTypes.bool,
};
